module.exports = __webpack_public_path__ + "static/media/title-hero-4.fe77ad16.jpg";